import router from '@/router'

const initPageTabs = [
    {
        name: 'Main', // 路由命名
        title: '首页', // 顶部导航栏显示的名字
        path: '/home', // 路由跳转路径
        isSelect: true, // 是否被选中
        params: null, // 路由参数
    }
]

const state = {
    pageTabs: initPageTabs, // 页面顶部路由集合
    curIndex: 0, // 当前adtive路由下标
}

const mutations = {
    SET_PAGE_TABS: (state, pageTabs) => {
        state.pageTabs = pageTabs
    },
    SET_CUR_INDEX: (state, index) => {
        state.curIndex = index
    },
}

const actions = {
    init({ commit }) {
        commit('SET_PAGE_TABS', initPageTabs.slice(0,1))
        commit('SET_CUR_INDEX', 0)
    },

    /**
     * 添加导航栏对象
     * @param {*} param0 
     * @param {添加的路由对象，注意格式对应} tabObj 
     */
    addTab({ commit, state, dispatch }, tabObj) {
        if (!tabObj) return

        let curIndex = state.curIndex
        const pageTabs = state.pageTabs

        if (ifHaveSameTab(tabObj, pageTabs)) {
            const index = getPageTabsIndex(tabObj.name, pageTabs)
            // 更新页面路由参数 防止路由参数更新无效的问题
            pageTabs[index] = tabObj
            commit('SET_PAGE_TABS', pageTabs)
            dispatch('switchTab', index)
            return
        }

        pageTabs.push(tabObj)
        curIndex = pageTabs.length - 1
        commit('SET_PAGE_TABS', pageTabs)
        commit('SET_CUR_INDEX', curIndex)
        routeGo(tabObj)
    },

    switchTab({ commit }, index) {
        const pageTabs = state.pageTabs
        commit('SET_CUR_INDEX', index)
        routeGo(pageTabs[index])
    },

    /**
     * 删除导航栏
     * @param {*} param0 
     * @param {index为空时默认删除当前tab} index 
     */
    deleteTab({ commit, dispatch, state }, deleteIndex) {
        let index = deleteIndex || state.pageTabs.length - 1
        // let curIndex = state.curIndex -1 
        let curIndex = state.pageTabs.length-2; 
        const pageTabs = state.pageTabs
        pageTabs.splice(index, 1)
        commit('SET_PAGE_TABS', pageTabs)
        if (state.curIndex == index) {
            // 删除的是最后一个导航栏 需要切换导航栏
            dispatch('switchTab', curIndex)
        } else {
            commit('SET_CUR_INDEX', curIndex)
        }
    },
}

function routeGo(routeObj) {
    router.push({
        name: routeObj.name,
        params: routeObj.params || '',
        title: routeObj.title || '运立方'
    })
}

// 检查是否含有相同的导航栏对象
function ifHaveSameTab(curtab, pageTabs) {
    return pageTabs.some(item => {
        return item.name === curtab.name
    })
}

// 获取name在pagetabs的索引
function getPageTabsIndex(name, pageTabs) {
    return pageTabs.findIndex(item => {
        return item.name === name
    })
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}